import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';

import "./Projects.scss";

class Projects extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let projects = this.state.data.projects;

        return (
            <section id="projects">
                <Container fluid>
                    <Row>
                        <Fade right delay={200} duration={800} distance="20%" fraction={1}>
                            <h2 className="section-title">Projects</h2>
                        </Fade>
                        <Fade left delay={400} duration={800} distance="500px" fraction={1}>
                            <div className="section-title-underline"></div>
                        </Fade>
                    </Row>
                    <Row>
                        {projects.map((project, index) => (
                            <Col key={index} sm={12} md={6} lg={4} className="project">
                                <Flip right delay={500} duration={600} fraction={1}>
                                    <Link to={{
                                        pathname: `/projects/${project.name.replace(/\s+/g, '-').toLowerCase()}`,
                                        state: { project: project }
                                    }} className="project-link">
                                        <div className="project-overlay">
                                            <h6 className="project-title">{project.name}</h6>
                                            <p className="project-description">{project.description}</p>
                                        </div>
                                        <Image src={"/images/" + project.coverimage} rounded />
                                    </Link>
                                </Flip>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        );
    }
}

export default Projects;
